module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-register-box"
  }, [_c('plex-header'), _vm._v(" "), (_vm.autoLogging) ? _c('div', {
    staticClass: "text-center auto-login"
  }, [_c('spinner', {
    attrs: {
      "show": _vm.autoLogging
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('logging')))])], 1) : _c('div', {
    staticClass: "login-register"
  }, [_c('router-view', {
    staticClass: "login-register-content"
  })], 1), _vm._v(" "), _c('plex-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7609ac78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/loginRegister/LoginRegister.vue
// module id = 1357
// module chunks = 1